/* global Config */

// Vendor Libs
import React from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter, Route} from 'react-router-dom';
import {hot} from 'react-hot-loader/root';
import store from './components/redux/store';

// Material UI
import {ThemeProvider} from '@material-ui/styles';

// Components
import Theme from './theme';
import Main from './components/layout/main';

const App = () => (
  <ThemeProvider theme={Theme}>
    <Provider store={store}>
      <BrowserRouter>
        <Route path="/" component={Main} />
      </BrowserRouter>
    </Provider>
  </ThemeProvider>
);

export default Config.base.env === 'development' ? hot(App) : App;
